export function notifySessionExpired() {
  window.dispatchEvent(new Event('session-expired'));
}
